export const permissionForLateDataEntryConstants = {
	GetPaged: {
		SUCCESS : 'GET_PAGED_COUNTRY_SUCCESS',
		REQUEST : 'GET_PAGED_COUNTRY_REQUEST',
		FAILURE : 'GET_PAGED_COUNTRY_FAILURE'
	},
	Create: {
		REQUEST : 'CREATE_COUNTRY_REQUEST',
		SUCCESS : 'CREATE_COUNTRY_SUCCESS',
		FAILURE : 'CREATE_COUNTRY_FAILURE'
	},
	Delete: {
		REQUEST : 'DELETE_COUNTRY_REQUEST',
		SUCCESS : 'DELETE_COUNTRY_SUCCESS',
		FAILURE : 'DELETE_COUNTRY_FAILURE'
	},
	CLEAR: 'CLEAR_COUNTRY'
}